module.exports = __webpack_public_path__ + "static/img/zhuangbei.aface73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/zhuangbei.png
// module id = M0tk
// module chunks = 0